export const statusCounter = (statuses: number[], fieldName: string, receivedCounts: Array<Record<string, number>>) => {
  const counts = (receivedCounts ?? []).filter((item) => item[fieldName] != null && item.count != null);
  const mergedArray = statuses.map((statusId) => {
    const foundItem = counts.find((item) => item[fieldName] === statusId);
    return {
      [fieldName]: statusId,
      count: foundItem ? foundItem.count : 0
    };
  });
  return [...counts.filter((item) => !statuses.includes(item[fieldName])), ...mergedArray];
};
